// extracted by mini-css-extract-plugin
export default {"main":"Main_main__dMJ2B","active":"Main_active__hV7Hp"};